var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaveImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_5897)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2216_5897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0892 12.4225L11.1783 14.3333L13.0892 16.2442C13.415 16.57 13.415 17.0967 13.0892 17.4225C12.9267 17.585 12.7133 17.6667 12.5 17.6667C12.2867 17.6667 12.0733 17.585 11.9108 17.4225L10 15.5117L8.08917 17.4225C7.92667 17.585 7.71333 17.6667 7.5 17.6667C7.28667 17.6667 7.07333 17.585 6.91083 17.4225C6.585 17.0967 6.585 16.57 6.91083 16.2442L8.82167 14.3333L6.91083 12.4225C6.585 12.0967 6.585 11.57 6.91083 11.2442C7.23667 10.9183 7.76333 10.9183 8.08917 11.2442L10 13.155L11.9108 11.2442C12.2367 10.9183 12.7633 10.9183 13.0892 11.2442C13.415 11.57 13.415 12.0967 13.0892 12.4225ZM20 6.83333V16.8333C20 19.1308 18.1308 21 15.8333 21H4.16667C1.86917 21 0 19.1308 0 16.8333V6.83333C0 4.53583 1.86917 2.66667 4.16667 2.66667H5V1.83333C5 1.3725 5.37333 1 5.83333 1C6.29333 1 6.66667 1.3725 6.66667 1.83333V2.66667H13.3333V1.83333C13.3333 1.3725 13.7067 1 14.1667 1C14.6267 1 15 1.3725 15 1.83333V2.66667H15.8333C18.1308 2.66667 20 4.53583 20 6.83333ZM1.66667 6.83333V7.66667H18.3333V6.83333C18.3333 5.455 17.2117 4.33333 15.8333 4.33333H4.16667C2.78833 4.33333 1.66667 5.455 1.66667 6.83333ZM18.3333 16.8333V9.33333H1.66667V16.8333C1.66667 18.2117 2.78833 19.3333 4.16667 19.3333H15.8333C17.2117 19.3333 18.3333 18.2117 18.3333 16.8333Z",
    fill: "#3D3E58"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_5897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6667,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2216_5897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveImg);
export default __webpack_public_path__ + "static/media/LeaveImg.95aaadea6fa313b7497db8e32039105e.svg";
export { ForwardRef as ReactComponent };